import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rc_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function resolveImageUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("/projects/")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return `${API_BASE}/files/${path}`;
}

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return JSON.stringify(detail);
}

export function formatRental(amount) {
  return `₹${Number(amount).toLocaleString("en-IN")}`;
}

export function formatINR(amount) {
  if (amount == null) return "";
  const n = Number(amount);
  if (Number.isNaN(n)) return String(amount);
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
  return `₹${n.toLocaleString("en-IN")}`;
}
